import React from 'react';
import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      background: ${theme.color.white};
      border-left: 1px solid ${theme.color.neutral_100};
      border-right: 1px solid ${theme.color.neutral_100};
      border-bottom: 1px solid ${theme.color.neutral_100};
      border-radius: 0 0 ${theme.radius.xs} ${theme.radius.xs};
      padding: 1rem;
    `;
  }};
`;
